// extracted by mini-css-extract-plugin
export default {"productCarousel":"q2-z"};